<div class="container">
  <nav aria-label="breadcrumb" style="--bs-breadcrumb-divider: '>';" aria-label="breadcrumb">
    <ol class="breadcrumb border-0 p-0">
      <li class="breadcrumb-item">
        <a class=" text-decoration-none" routerLink="/">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
               class="bi bi-house-door-fill" viewBox="0 0 16 16">
            <path
              d="M6.5 14.5v-3.505c0-.245.25-.495.5-.495h2c.25 0 .5.25.5.5v3.5a.5.5 0 0 0 .5.5h4a.5.5 0 0 0 .5-.5v-7a.5.5 0 0 0-.146-.354L13 5.793V2.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1.293L8.354 1.146a.5.5 0 0 0-.708 0l-6 6A.5.5 0 0 0 1.5 7.5v7a.5.5 0 0 0 .5.5h4a.5.5 0 0 0 .5-.5"/>
          </svg>
          <span jhiTranslate="global.menu.home">news</span>
        </a>
      </li>

      <li class="breadcrumb-item active text-secondary" aria-current="page">
        5.10.2016
      </li>
    </ol>
  </nav>

  <div class="row">
    <div class="col d-flex flex-column position-static">
      <h3 class="mb-0 text-primary">sexcare als Podiumsgast Kulturzyklus Kontrast 2016 FHS St. Gallen, 26. Oktober
        2016</h3>
      <div class="mb-1 text-body-secondary">5.10.2016</div>
      <p class="mb-auto"><q>The Sessions</q> Ein Film zeigt emotional, wie der bis zum Hals gelähmte Mark O’Brien mit 38
        Jahren beschliesst, seine Jungfräulichkeit zu verlieren, und dabei die wundervolle Sexualität entdeckt… Pikant:
        ein Pfarrer übernimmt die Rolle als hilfreicher Vermittler.
        Anschliessendes Podiums- und Publikumsgespräch mit Isabelle Kölbl von sexcare und Alex Oberholzer,
        Filmjournalist bei Radio24.
        Wir freuen uns auf spannende Gespräche!
      </p>
    </div>
    <div class="col-auto h d-lg-block">
      <img src="/../../../content/blog/blog1_2.jpg" alt="sessions bild" width="200" class="object-fit-scale">
    </div>
  </div>
  <div class="row mt-4">
      <a href="https://www.youtube.com/embed/xo2fMyMUatM?feature=oembed" target="_blank"><img src="/../../../content/blog/blog1_3.png" class="d-block w-100"></a>
<!--      <iframe src="https://www.youtube.com/embed/xo2fMyMUatM?feature=oembed" title="the session video"-->
<!--              allowfullscreen></iframe>-->
  </div>
</div>
